export default {
  QUERY_MAINTENANCE_TYPE: {
    url: '/api/v1/maintenances/types',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  QUERY_MAINTENANCE_LIST: {
    url: '/api/v1/admin/maintenances',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  PUT_MAINTENANCE: {
    url: '/api/v1/admin/maintenances',
    method: 'put',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  QUERY_MAINTENANCE_OVERVIEW: {
    url: '/api/v1/admin/maintenances/overview',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  }
}
